<template lang="pug">
#drawer-menu-camadas
    el-drawer(
        :title='$t("mensagens.menuCamadas.titulo")',
        direction='rtl',
        :class='menuMaior ? "drawer-menu-camadas" : "drawer-menu-camadas menor"',
        :visible.sync='show',
        :before-close='closeDrawerMenuCamadas',
        :wrapperClosable='false',
        :modal='false',
        :lock-scroll='true',
        :append-to-body='false',
        :close-on-press-escape='true',
        :size='menuMaior ? 360 : 247',
        :show-close='false'
    )
        template(slot='title', slot-scope='scope')
            .header-principal
                .titulo-drawer
                    i.mdi.mdi-wrench-outline.mdi-flip-h
                    |
                    | {{ $t('mensagens.menuCamadas.titulo') }}
                button.el-drawer__close-btn(
                    type='button',
                    @click='closeDrawerMenuCamadas'
                )
                    i.el-dialog__close.el-icon.el-icon-close
            el-input.w-100(
                :placeholder='$t("mensagens.menuCamadas.placeholderPesquisa")',
                v-model='termoPesquisaCamadas',
                clearable
            )
                i.el-icon-search(slot='prefix')
        .card-container
            el-tabs
                el-tab-pane
                    span(slot='label')
                        | {{ $t('mensagens.menuCamadas.abaTodas') }}
                    .col-12.menu-expand-collapse-content-menu.d-flex.flex-row-reverse
                        .action-link(@click='handleExpandAllItems()')
                            span(
                                :class='expandirCamadas ? "mdi mdi-arrow-collapse mr-1" : "mdi mdi-arrow-expand mr-1"'
                            )
                            | {{ expandirCamadas ? $t("mensagens.menuCamadas.contrairCamadas") : $t("mensagens.menuCamadas.expandirCamadas") }}
                    el-tree#viewTreeCamadas(
                        ref='viewTreeCamadas',
                        :data='items',
                        :props='defaultProps',
                        :filter-node-method='filterNode',
                        node-key='id',
                        :empty-text='termoPesquisaCamadas.length === 0 ? $t("mensagens.menuCamadas.nenhumaCamadaDisponivel") : $t("mensagens.menuCamadas.nenhumaCamadaEncontrada")',
                        @node-collapse='handleNodeClick',
                        @node-expand='handleNodeClick',
                        v-loading='buscaBinariaIniciada'
                    )
                        span(
                            v-if='checkPermissaoItems(data, node)',
                            slot-scope='{ node, data }'
                        )
                            DrawerMenuCamadasTreeItem(
                                :node='node',
                                :data='data',
                                :isChecked='verificaLocalidadeNivelUmChecked(data.codigo)',
                                @onChangeCheckboxCamadas='onChangeCamada',
                                :menuMaior='menuMaior'
                            )
                el-tab-pane
                    span(slot='label')
                        | {{ $t('mensagens.menuCamadas.abaAtivas') }}
                    .col-12.menu-expand-collapse-content-menu-camadas-ativas.d-flex.flex-column
                        .action-link(v-if='camadasAtivas.length > 0')
                            span(@click='limparSelecaoCamadasAtivas()')
                                | {{ $t('mensagens.menuCamadas.limparSelecao') }}
                        DrawerMenuCamadasAtivas(
                            :mapa='mapa',
                            :showStatesLayers='true',
                            :layersAtivos='camadasAtivas',
                            @orderLayersCamadasAtivas='processarOrderLayersCamadasAtivas',
                            @removerCamada='removerCamada',
                            :menuMaior='menuMaior'
                        )
</template>

<script>
import L from 'leaflet';
import { URL_GEOSERVER } from '@/utils/mapa/mapa.config';

import store from '@/store';

import { GeoService, CamadasService } from '@/services/CamadasService';
import camadasVisualizacao from '@/utils/camadasV2.js';

import estilos from '@/utils/mapa/mapa.estilos';
import Mapa from '@/utils/mapa/mapa.service';

import DrawerMenuCamadasTreeItem from '@/components/DrawerMenuCamadasTreeItem.vue';
import DrawerMenuCamadasAtivas from '@/components/DrawerMenuCamadasAtivas.vue';

import _ from 'lodash';
import { mapState } from 'vuex';

import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'DrawerMenuCamadas',

    components: {
        DrawerMenuCamadasTreeItem,
        DrawerMenuCamadasAtivas
    },

    props: {
        show: {
            type: Boolean,
            required: false,
            default: false
        },
        menuMaior: {
            type: Boolean,
            required: false,
            default: false
        },
        limparMenuCamadasAtivo: {
            type: Boolean,
            required: false,
            default: false
        },
        mapa: {
            type: Object,
            required: true
        },
        showStatesLayers: {
            type: Boolean,
            required: false,
            default: true
        }
    },

    data() {
        return {
            layers: [],
            layersFiltrados: [],
            resultados: [],
            geometria: null,
            items: [],
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            primeiroCarregamento: false,
            camadasPermitidasPorUsuario: [],
            termoPesquisaCamadas: '',
            camadasAtivas: [],
            nodeAtivos: [],
            expandirCamadas: false,
            buscaBinariaIniciada: false,
            ambientes: AmbientesEmpresas
        };
    },

    computed: {
        ativarCamadaCar() {
            return store.state.ativarCamadaCar;
        },

        carSelecionadoNaPopup() {
            return store.state.carSelecionadoNaPopup;
        },

        showCamadaToEdit_() {
            return {
                flag: store.state.showCamadaToEdit,
                identifier: store.state.identificadorGeometria
            };
        },

        geometriaToShow() {
            return store.state.geometriaToShow;
        },

        identificadorGeometria() {
            return store.state.identificadorGeometria;
        },

        limparUltimaGeometria() {
            return store.state.limparUltimaGeometria;
        },

        limparCamadas() {
            return store.state.limparCamadas;
        },

        ...mapState(['usuarioLogado'])
    },

    watch: {
        layers(list) {
            this.orderLayer(list);
        },

        ativarCamadaCar: {
            handler: _.debounce(function (newValue) {
                if (newValue) {
                    this.ativarCamadaCAR();
                } else {
                    this.desativarCamadaCAR();
                }
            }, 100)
        },

        carSelecionadoNaPopup(newValue) {
            if (newValue) {
                this.onCarSelecionadoNaPopup(newValue);
            }
        },

        showCamadaToEdit_(flag, identifier) {
            if (flag || identifier) {
                this.showCamadaToEdit(
                    this.geometriaToShow,
                    this.identificadorGeometria
                );
            }
        },

        limparUltimaGeometria(newValue) {
            if (newValue) {
                this.limparUltimaGeometriaSelecionadaCar();
            }
        },

        limparCamadas(newValue) {
            if (newValue) {
                const camadaCar = this.layers.find(
                    l => l.codigo === 'IMOVEL_RURAL'
                );
                this.desativarCamada(camadaCar);
                store.dispatch('setLimparCamadas', false);
            }
        },

        limparMenuCamadasAtivo(newValue) {
            if (newValue) {
                setTimeout(() => {
                    this.$emit('resetarLimparMenuCamadasAtivo');
                }, 100);
            }
        },

        show(newValue) {
            if (newValue && !this.primeiroCarregamento) {
                setTimeout(() => {
                    const nodes = this.$refs.viewTreeCamadas.store._getAllNodes();
                    // Faz a busca do checkbox de estados para setá-lo true
                    this.traverseTree(nodes);
                    this.buscaBinariaNodesCamadas(nodes);
                    this.primeiroCarregamento = true;
                }, 500);
            }
        },

        termoPesquisaCamadas(val) {
            this.$refs.viewTreeCamadas.filter(val);
        }
    },

    async created() {
        this.$bus.$off();
        this.buscaBinariaIniciada = true;
        var camadasPermitidasPorUsuarioState_ = this.camadasPermitidasPorUsuarioState();
        if (camadasPermitidasPorUsuarioState_.length > 0) {
            this.onCreateCamadasPermitidasPorUsuario(camadasPermitidasPorUsuarioState_, 'STATE');
        } else {
            await CamadasService.buscarCamadasUsuario()
                .then(({ data }) => {
                    this.onCreateCamadasPermitidasPorUsuario(data, 'SERVICE');
                })
                .catch(erro => {
                    this.$notify.error({
                        message: this.$t('mensagens.menuCamadas.erroBuscarCamadasUsuario')
                    });
                });
        }
    },

    beforeDestroy() {
        if (this.$refs.viewTreeCamadas) {
            for (
                let i = 0;
                i < this.$refs.viewTreeCamadas.store._getAllNodes().length;
                i++
            ) {
                this.$refs.viewTreeCamadas.store._getAllNodes()[
                    i
                ].data.icon = 'mdi mdi-folder-outline';
            }
        }
    },

    methods: {
        limparSelecaoCamadasAtivas() {
            this.camadasAtivas.forEach(camada => {
                const node = this.nodeAtivos.find(
                    n => n.data.codigo === camada.codigo
                );
                node.checked = false;
                this.onChangeCamada(camada, node);
            });
        },

        permissaoAmbiente(ambiente) {
            return this.usuarioLogado.paisGrupo === ambiente;
        },

        retornaCamadaLocalidadeNivel1() {
            if (this.usuarioLogado.paisGrupo === this.ambientes.PARAGUAY) {
                return 'PY_LOCALIDADE_NIVEL_1';
            } else {
                return 'BR_LOCALIDADE_NIVEL_1';
            }
        },

        verificaLocalidadeNivelUmChecked(codigoCamada) {
            if (
                this.permissaoAmbiente(this.ambientes.PARAGUAY) &&
                codigoCamada === 'PY_LOCALIDADE_NIVEL_1'
            ) {
                return true;
            }
            if (
                this.permissaoAmbiente(this.ambientes.BRASIL) &&
                codigoCamada === 'BR_LOCALIDADE_NIVEL_1'
            ) {
                return true;
            }

            return false;
        },

        processarOrderLayersCamadasAtivas(list) {
            this.orderLayer(list);
        },

        checkPermissaoItems(data, node) {
            if (data.icon) {
                if (data.children.length === 0) {
                    this.$refs.viewTreeCamadas.remove(node);
                    return false;
                }
                return true;
            } else {
                if (
                    data.codigo &&
                    this.camadasPermitidasPorUsuario.includes(data.codigo)
                ) {
                    return true;
                } else {
                    this.$refs.viewTreeCamadas.remove(node);
                    return false;
                }
            }
        },

        verificaPastaVazia(node) {
            if (!node) {
                return;
            }

            if (node.level !== 0) {
                const parent = node.parent;

                if (!parent) {
                    return;
                }
                // Verifica se todos os filhos do pai foram removidos
                if (parent.level !== 0) {
                    const allChildrenRemoved = parent.data.children.every(child => child.removido);

                    // Se todos os filhos foram removidos, removemos o pai também
                    if (allChildrenRemoved) {
                        this.verificaPastaVazia(parent.parent);
                        this.$refs.viewTreeCamadas.remove(node);
                        this.$refs.viewTreeCamadas.remove(parent);
                    }
                }
            }
        },

        removerAcentos(text) {
            return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        },

        filterNode(value, data) {
            if (!value) return true;

            const normalizedValue = this.removerAcentos(value.toLowerCase());
            const normalizedDataLabel = this.removerAcentos(
                data.label.toLowerCase()
            );

            if (data.checkbox) {
                return normalizedDataLabel.indexOf(normalizedValue) !== -1;
            }
        },

        handleNodeClick(node, prop) {
            if (prop.data.icon === 'mdi mdi-folder-outline') {
                prop.data.icon = 'mdi mdi-folder-open-outline';
            } else {
                prop.data.icon = 'mdi mdi-folder-outline';
            }
        },

        handleExpandAllItems(expand) {
            this.expandirCamadas = !this.expandirCamadas;
            for (
                let i = 0;
                i < this.$refs.viewTreeCamadas.store._getAllNodes().length;
                i++
            ) {
                this.$refs.viewTreeCamadas.store._getAllNodes()[i].expanded =
                    this.expandirCamadas;
                if (this.expandirCamadas) {
                    this.$refs.viewTreeCamadas.store._getAllNodes()[
                        i
                    ].data.icon = 'mdi mdi-folder-open-outline';
                } else {
                    this.$refs.viewTreeCamadas.store._getAllNodes()[
                        i
                    ].data.icon = 'mdi mdi-folder-outline';
                }
            }
        },

        closeDrawerMenuCamadas() {
            this.$emit('closeDrawerMenuCamadas');
        },

        removerCamada(camada) {
            const node = this.nodeAtivos.find(
                n => n.data.codigo === camada.codigo
            );
            node.checked = false;
            this.onChangeCamada(camada);
        },

        onChangeCamada(camada, node) {
            if (this.mapa.hasLayer(camada.leafletLayer)) {
                camada.ativo = false;
            } else {
                camada.ativo = true;
            }
            if (camada.ativo) {
                this.mapa.removeLayer(camada);
                this.ativarCamada(camada.leafletLayer);
                if (this.$route.name === 'CadastrarEditarTerritorio' && camada.codigo === 'IMOVEL_RURAL') {
                    this.mapa.on('click', this.buscar, this);
                }
                this.camadasAtivas.push(
                    this.layersFiltrados.filter(
                        l => l.codigo === camada.codigo
                    )[0]
                );
                this.$emit('atualizarListaCamadasModalInspecionar', this.camadasAtivas);
                if (node) {
                    this.nodeAtivos.push(node);
                }
            } else {
                this.desativarCamada(camada.leafletLayer);
                if (this.$route.name === 'CadastrarEditarTerritorio' && camada.codigo === 'IMOVEL_RURAL') {
                    this.mapa.off('click', this.buscar, this);
                }
                this.camadasAtivas = this.camadasAtivas.filter(
                    l => l.codigo !== camada.codigo
                );
                this.$emit('atualizarListaCamadasModalInspecionar', this.camadasAtivas);
                if (node) {
                    this.nodeAtivos = this.nodeAtivos.filter(
                        n => n.data.codigo !== node.codigo
                    );
                }
            }
            this.orderLayer(this.layers);
        },

        ativarCamada(camada) {
            if (camada && !this.mapa.hasLayer(camada)) {
                this.clearLayers();
                this.mapa.addLayer(camada);
                this.atualizarListaCamadasDiagnostico();
            }
        },

        desativarCamada(camada) {
            if (camada && this.mapa.hasLayer(camada)) {
                this.clearLayers();
                this.mapa.removeLayer(camada);
                this.atualizarListaCamadasDiagnostico();
            }
        },

        atualizarListaCamadasDiagnostico() {
            const camadasAtivas = this.camadasAtivas.filter(l => l.ativo === true);
            this.$bus.$emit('mapa:camadas-ativas-diagnostico', camadasAtivas);
        },

        orderLayer(list) {
            let mapa = this.mapa;
            let tam = list.length - 1;

            for (let i = tam; i >= 0; i--) {
                Object.entries(this.mapa._layers).map(function (item) {
                    if (
                        item[1]['wmsParams'] !== undefined &&
                        list[i].layerName === item[1]['wmsParams']['layers']
                    ) {
                        mapa._layers[item[0]].bringToFront();
                    }
                });
            }
        },

        clearLayers() {
            if (this.geometria) {
                if (store.state.territoryTableData.length) {
                    const existeNaTabela = store.state.territoryTableData.find(
                        t =>
                            t.identificadorGeometria ===
                            this.geometria.identificadorGeometria
                    );
                    if (!existeNaTabela) {
                        this.mapa.removeLayer(this.geometria);
                    }
                } else {
                    this.mapa.removeLayer(this.geometria);
                }
                this.geometria = null;
                store.dispatch('setCarSelecionadoNaPopup', null);
            }
        },

        limparUltimaGeometriaSelecionadaCar() {
            if (this.geometria) {
                if (store.state.territoryTableData.length) {
                    const existeNaTabela = store.state.territoryTableData.find(
                        t =>
                            t.identificadorGeometria ===
                            this.geometria.identificadorGeometria
                    );
                    if (!existeNaTabela) {
                        this.mapa.removeLayer(this.geometria);
                    }
                } else {
                    this.mapa.removeLayer(this.geometria);
                }
                this.geometria = null;
            }
            store.dispatch('setLimparUltimaGeometria', false);
        },

        ativarCamadaCAR() {
            const camadaCar = this.layersFiltrados.find(
                l => l.codigo === 'IMOVEL_RURAL'
            );
            if (camadaCar) {
                camadaCar.ativo = false;
                this.onChangeCamada(camadaCar);
                this.mapa.on('click', this.buscar, this);
            }
        },

        desativarCamadaCAR() {
            const camadaCar = this.layersFiltrados.find(
                l => l.codigo === 'IMOVEL_RURAL'
            );
            camadaCar.ativo = false;
            setTimeout(() => {
                this.clearLayers();
                this.mapa.removeLayer(camadaCar.leafletLayer);
                this.atualizarListaCamadasDiagnostico();
            }, 500);
            this.mapa.off('click', this.buscar, this);
        },

        buscar(e) {
            GeoService.getCarPorCoordenadas(e.latlng.lat, e.latlng.lng).then(
                ({ data }) => {
                    if (!data[0].resultados || !data[0].resultados.length) {
                        return;
                    }

                    this.resultados = data[0].resultados;

                    this.resultados.forEach(resultado => {
                        this.clearLayers();
                        this.geometria = Mapa.criarGeoJSON(
                            resultado.geometry,
                            estilos.Geometria.imovelRuralCandidato
                        );
                        resultado.properties.identificadorGeometria =
                            this.geometria._leaflet_id;
                        this.geometria.identificadorGeometria =
                            this.geometria._leaflet_id;

                        store.dispatch('setCarSelecionadoNaPopup', resultado);
                        this.mapa.addLayer(this.geometria);
                        var bounds = this.geometria.getBounds();
                        this.mapa.fitBounds(bounds);

                        this.$nextTick(() => {
                            const popup = document.getElementById('popup');
                            if (popup) {
                                popup.style.display = 'block';
                            }

                            this.geometria.openPopup();
                        });
                    });
                }
            );
        },

        carWasSelectedBefore(carCode) {
            let result = false;
            if (store.state.territoryTableData.length === 0) {
                result = false;
            } else {
                store.state.territoryTableData.forEach(item => {
                    if (item.codigo === carCode) {
                        result = true;
                    }
                });
            }
            return result;
        },

        onCarSelecionadoNaPopup(codigoCAR) {
            let resultado = this.resultados.find(
                r => r.properties.codigo === codigoCAR
            );
            if (resultado) {
                let type = 'CAR';
                resultado = { ...resultado, ...resultado.properties, type };
                delete resultado.properties;
                resultado.area_ha = resultado.areaHa;
                if (!this.carWasSelectedBefore(resultado.codigo)) {
                    store.dispatch('setTerritoryTableData', resultado);
                } else {
                    this.$notify.error({
                        message: 'CAR já selecionado!'
                    });
                }
                store.dispatch('setCarSelecionadoNaPopup', null);

                this.geometria = null;
            }
        },

        showCamadaToEdit(geometriaToShow, identificadorGeometria) {
            this.clearLayers();
            this.geometria = Mapa.criarGeoJSON(
                geometriaToShow,
                estilos.Geometria.imovelRuralCandidato
            );
            this.geometria.identificadorGeometria = identificadorGeometria;
            this.mapa.addLayer(this.geometria);
            var bounds = this.geometria.getBounds();

            // Fit the map to the polygon bounds
            this.mapa.fitBounds(bounds);
            store.dispatch('setShowCamadaToEdit', {
                showCamadaToEdit: true,
                geometriaToShow: geometriaToShow,
                identificadorGeometria: identificadorGeometria
            });
        },

        camadasPermitidasPorUsuarioState() {
            return store.state.camadasPermitidasPorUsuarioState || [];
        },

        objetoFiltrado(obj) {
            let allSubChildrenInvalid = false;
            if (obj.children && Array.isArray(obj.children)) {
                obj.children = obj.children.map(this.objetoFiltrado).filter(child => child);
            }
            if (!obj.children && !obj.checkbox) {
                allSubChildrenInvalid = true;
            }

            const allChildrenInvalid = obj.children && obj.children.every(child =>
                !child.checkbox && (!child.children || child.children.length === 0)
            );

            if (obj.checkbox || (!allChildrenInvalid && allSubChildrenInvalid === false)) {
                return obj;
            } else {
                return null;
            }
        },

        traverseTree(nodes) {
            for (const node of nodes) {
                if (node.data.label === 'Áreas administrativas') {
                    this.ativarCamadaEstados(node);
                    break;
                }
                if (node.childNodes) {
                    this.traverseTree(node.childNodes);
                }
            }
        },

        ativarCamadaEstados(node) {
            for (const childNode of node.childNodes) {
                if ((childNode.data.label === 'Estados' && this.usuarioLogado.paisGrupo !== this.ambientes.PARAGUAY) ||
                    ((childNode.data.label === 'Departamentos Paraguai' && this.usuarioLogado.paisGrupo === this.ambientes.PARAGUAY))) {
                    childNode.checked = true;
                    this.nodeAtivos.push(childNode);
                    this.ativarCamada(childNode.data.leafletLayer);
                    break;
                }
            }
        },

        onCreateCamadasPermitidasPorUsuario(data, type) {
            if (data && data.length > 0) {
                    this.camadasPermitidasPorUsuario = data;
                    if (this.usuarioLogado.paisGrupo === this.ambientes.PARAGUAY && !this.camadasPermitidasPorUsuario.includes('PY_LOCALIDADE_NIVEL_1')) {
                        this.camadasPermitidasPorUsuario.push('PY_LOCALIDADE_NIVEL_1');
                    }
                    if (this.usuarioLogado.paisGrupo === this.ambientes.BRASIL && !this.camadasPermitidasPorUsuario.includes('BR_LOCALIDADE_NIVEL_1')) {
                        this.camadasPermitidasPorUsuario.push('BR_LOCALIDADE_NIVEL_1');
                    }

                    const camadasFiltradasVisualizacao = camadasVisualizacao.map(this.objetoFiltrado).filter(item => item !== null);
                    this.items = [...camadasFiltradasVisualizacao];
                    this.layers = [...camadasFiltradasVisualizacao];

                    let camadasVisualizacaoFlat = [];

                    this.layers.map(parent => {
                        if (parent.children) {
                            if (
                                parent.children.codigo &&
                                data.includes(parent.children.codigo)
                            ) {
                                camadasVisualizacaoFlat.push(parent.children);
                            }
                            parent.children.map(child => {
                                if (
                                    child.codigo &&
                                    data.includes(child.codigo)
                                ) {
                                    camadasVisualizacaoFlat.push(child);
                                }
                                if (child.children) {
                                    child.children.map(subChild => {
                                        if (
                                            subChild.codigo &&
                                            data.includes(subChild.codigo)
                                        ) {
                                            camadasVisualizacaoFlat.push(
                                                subChild
                                            );
                                        }
                                    });
                                }
                            });
                        }
                    });

                    if (type !== 'STATE') {
                        store.dispatch(
                            'setCamadasPermitidasPorUsuario',
                            data
                        );
                    }

                    const camadaLocalidadeNivel1 = this.retornaCamadaLocalidadeNivel1();

                    camadasVisualizacaoFlat.forEach(layer => {
                        const url = layer.local ? URL_GEOSERVER : layer.path;

                        let options = {
                            codigo: layer.codigo,
                            layers: layer.layerName,
                            transparent: true,
                            format: 'image/png',
                            idEmpresa: '',
                            path: layer.path,
                            styles: layer.styleName || '',
                            opacity: layer.opacidade / 100
                        };

                        if (layer.cql_filter) {
                            options.cql_filter = layer.cql_filter;
                        }

                        layer.leafletLayer = L.tileLayer.wms(url, options);

                        const camadaEstados = camadasVisualizacaoFlat.find(
                            l => l.codigo === camadaLocalidadeNivel1
                        );

                        if (camadaEstados && this.showStatesLayers) {
                            camadaEstados.ativo = true;

                            setTimeout(() => {
                                this.desativarCamada(
                                    camadaEstados.leafletLayer
                                );
                            }, 200);

                            setTimeout(() => {
                                this.ativarCamada(camadaEstados.leafletLayer);
                            }, 300);
                        }
                    });
                    this.layersFiltrados = camadasVisualizacaoFlat;

                    this.camadasAtivas.push(
                        this.layersFiltrados.filter(l => l.codigo === camadaLocalidadeNivel1)[0]
                    );
                    this.$emit('atualizarListaCamadasModalInspecionar', this.camadasAtivas);
                } else {
                    this.$notify.error({
                        message: this.$t('mensagens.menuCamadas.erroBuscarCamadasUsuario')
                    });
                }
        },

        buscaBinariaNodesCamadas(nodes) {
            let result = false;
            for (let i = 0; i < nodes.length; i++) {
                const data = nodes[i].data;
                const node = nodes[i];
                if (node.level !== 0) {
                    if (
                        data.codigo &&
                        this.camadasPermitidasPorUsuario.includes(data.codigo)
                    ) {
                        result = true;
                    } else if (data.codigo && !this.camadasPermitidasPorUsuario.includes(data.codigo)) {
                        node.data.removido = true;
                        if ((data.children && data.children.length === 0) || data.codigo) {
                            this.verificaPastaVazia(node);
                        }
                        result = false;
                    }

                    if (data.icon) {
                        this.buscaBinariaNodesCamadas(node.childNodes);
                        result = true;
                    }
                    setTimeout(() => {
                        this.buscaBinariaIniciada = false;
                    }, 2000);
                }
            }
            return result;
        }
    }
};
</script>

<style lang="scss">
#drawer-menu-camadas {
    font-family: 'Roboto', 'sans serif';

    .el-drawer.rtl {
        border-radius: 0 3px 3px 0;
    }

    .drawer-menu-camadas {
        z-index: 500 !important;
        position: absolute;

        .el-input--prefix .el-input__inner {
            padding-left: 35px;
        }

        #el-drawer__title > button > i {
            &::before {
                color: #3b3b3b;
                font-weight: 600;
                font-size: 16px;
            }
        }

        #el-drawer__title
            > div.w-100.el-input.el-input--prefix
            > .el-input__prefix {
            top: 10px;
            left: 10px;
            color: var(--primary) !important;
            i {
                font-size: 20px;
            }
        }

        #el-drawer__title
            > div.w-100.el-input.el-input--suffix
            > .el-input__suffix {
            color: var(--primary) !important;
            i {
                font-size: 20px;
            }
        }
    }

    .drawer-menu-camadas.menor {
        .el-input--prefix .el-input__inner {
            padding-left: 35px;
        }

        #el-drawer__title > button > i {
            &::before {
                color: #3b3b3b;
                font-weight: 600;
                font-size: 14px;
            }
        }

        #el-drawer__title > div.w-100.el-input.el-input--prefix > span {
            top: 10px;
            left: 10px;
            color: var(--primary) !important;
            i {
                font-size: 20px;
            }
        }

        #el-drawer__title
            > div.w-100.el-input.el-input--suffix
            > .el-input__suffix {
            color: var(--primary) !important;
            i {
                font-size: 20px;
            }
        }
    }

    .el-drawer__body {
        @include scroll-bar();
    }

    .card-container {
        height: 100%;
        background-color: var(--white);
        // padding: 5px 8px;
        overflow-y: auto;
        overflow-x: hidden;

        .el-menu {
            width: 100%;
            border-right: none;
            display: flex;
            flex-direction: column;

            .el-menu-item,
            .el-submenu__title {
                padding: 0;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding-left: 8px !important;
                height: 42px;
                line-height: 42px;

                i {
                    color: #3b3b3b;
                    transition: all 0.3s ease-in-out;
                }

                i.mdi {
                    margin-right: 11px;
                    text-align: center;
                    font-size: 22px;
                    vertical-align: middle;
                }

                i.el-icon-arrow-down {
                    transform: rotate(270deg);
                    color: #3b3b3b;
                    font-size: 16px;
                    font-weight: 600;
                }

                span {
                    width: 100%;
                    color: #3b3b3b;
                    font-weight: 400;
                    font-size: 14px;
                    transition: color 0.3s ease-in-out;
                    display: flex;
                    justify-content: space-between;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    line-height: 16px;
                    letter-spacing: 0em;
                    text-align: left;
                }

                .el-tooltip {
                    padding: 0px 18px;
                }
            }

            .el-submenu__icon-arrow {
                right: 10px;
            }

            .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
                transform: rotate(360deg) !important;
            }

            .el-menu-item.is-active {
                color: var(--primary);
                background-color: #b5dc6966;

                i {
                    color: var(--primary);
                }

                span {
                    color: var(--primary);
                    font-weight: 500;
                }
            }
        }

        .el-menu.menu-menor {
            width: 100%;
            border-right: none;
            display: flex;
            flex-direction: column;

            .el-menu-item,
            .el-submenu__title {
                padding: 0;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding-left: 8px !important;
                height: 42px;
                line-height: 42px;

                i {
                    color: #3b3b3b;
                    transition: all 0.3s ease-in-out;
                }

                i.mdi {
                    margin-right: 11px;
                    text-align: center;
                    font-size: 18px;
                    vertical-align: middle;
                }

                i.el-icon-arrow-down {
                    transform: rotate(270deg);
                    color: #3b3b3b;
                    font-size: 14px;
                    font-weight: 600;
                }

                span {
                    width: 100%;
                    color: #3b3b3b;
                    font-weight: 400;
                    font-size: 12px;
                    transition: color 0.3s ease-in-out;
                    display: flex;
                    justify-content: space-between;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    line-height: 16px;
                    letter-spacing: 0em;
                    text-align: left;
                }

                .el-tooltip {
                    padding: 0px 18px;
                }
            }

            .el-submenu__icon-arrow {
                right: 10px;
            }

            .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
                transform: rotate(360deg) !important;
            }

            .el-menu-item.is-active {
                color: var(--primary);
                background-color: #b5dc6966;

                i {
                    color: var(--primary);
                }

                span {
                    color: var(--primary);
                    font-weight: 500;
                }
            }
        }

        .el-menu:not(.el-menu--collapse) {
            width: 100%;

            &::before {
                content: '';
                position: absolute;
                width: 32px;
                height: 15px;
                top: -5px;
                right: -32px;
                border-radius: 32px 10px 40px 10px;
                -webkit-box-shadow: -20px -20px 0 var(--primary);
                box-shadow: -14px -3px 0 var(--primary);
                z-index: -1;
            }
        }

        .menu-expand-collapse-content-menu {
            box-sizing: border-box;
            font-size: 12px;
            color: #777;
            line-height: 30px;
            vertical-align: middle;
            margin-top: 46px;

            .action-link {
                height: 30px;
                cursor: pointer;
                padding-left: 5px;
                padding-right: 5px;
                font-size: 15px;

                &:hover {
                    color: var(--primary);
                }
            }
        }

        .menu-expand-collapse-content-menu-camadas-ativas {
            margin-top: 46px;
            padding: 0;

            .action-link {
                color: #076cca;
                margin-bottom: 18px;
                height: 30px;

                span {
                    cursor: pointer;
                    font-size: 15px;
                }
            }
        }

        .el-tree-node__expand-icon {
            display: none;

            &.expanded {
                span {
                    i {
                        transform: rotate(90deg);
                    }
                }
            }
        }

        .el-tree {
            margin-top: 15px;

            .mdi {
                color: var(--primary);
            }
        }

        .el-tree-node__content {
            margin: 5px 0 5px 0;
        }

        .el-tree-node__content i {
            font-size: 19px;
        }

        .el-tree-node__content span {
            font-size: 15px;
            font-weight: 400;
            line-height: 16px;
            letter-spacing: 0em;
            text-align: left;
            margin-left: 5px;

            & > span:nth-child(1) {
                margin-left: 4px !important;
            }
        }

        .el-tabs.el-tabs--top {
            .el-tabs__nav.is-top {
                background-color: #e9e9e9;
                width: 100%;
            }

            .el-tabs__content {
                padding: 5px 8px;
            }

            .el-tabs__nav-wrap.is-scrollable {
                padding: 0;
            }

            .el-tabs__nav-prev,
            .el-tabs__nav-next {
                display: none;
            }

            .el-tabs__nav-scroll {
                display: flex;
                justify-content: center;
            }

            .el-tabs__item {
                padding: 0 !important;
            }

            #tab-0 {
                width: 180px;

                span {
                    margin-left: 70px;
                }
            }

            #tab-1 {
                width: 180px;

                span {
                    margin-left: 70px;
                }
            }
        }

        .el-tabs__header {
            position: absolute;
            background-color: #e9e9e9;
            width: 100%;
        }
    }

    .el-input__inner {
        border-radius: 5px;
    }

    .header-principal {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        width: 100%;

        .titulo-drawer {
            font-size: 17px;
            font-weight: 500;
            color: var(--primary);
        }

        .titulo-drawer-menor {
            font-size: 15px;
            font-weight: 500;
            color: var(--primary);
        }

        .el-drawer__close-btn {
            i {
                color: #3b3b3b;
                font-weight: 600;
                font-size: 16px;
            }
        }
    }

    .text-align-right {
        text-align: right;
    }

    .menu-expand-collapse .menu-expand-collapse-title h2 {
        padding-top: 19px;
        font-size: 16px;
        padding-right: 16px;
        padding-left: 22px;
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .pull-left {
        float: left;
    }

    .el-drawer__header {
        flex-direction: column;
        background-color: #e9e9e9;
        padding: 15px !important;
        margin-bottom: 0px;
    }

    .menu-expand-collapse-title {
        width: 100%;
        background-color: #ecf0f1;
    }

    .menu-expand-collapse .menu-expand-collapse-collapse-icon {
        position: absolute;
        right: 15px;
        top: 17px;
        z-index: 10001;
        font-size: 16px;
    }

    .action-icon {
        cursor: pointer;
        color: #777;
    }

    .menor {
        .el-tabs__item * {
            font-size: 14px;
        }
        .el-tabs__content .el-tab-pane * {
            font-size: 15px;
        }
        .el-tabs__content .el-tab-pane {
            .menu-expand-collapse-content-menu .action-link {
                font-size: 14px;
            }
            #drawer-menu-camadas-ativas * {
                font-size: 14px;
            }
            .menu-expand-collapse-content-menu-camadas-ativas .action-link span {
                font-size: 14px;
            }
        }
        .el-tabs.el-tabs--top {
            #tab-0 {
                width: 50%;
                span {
                    margin-left: 2vw;
                }
            }
            
            #tab-1 {
                width: 50%;
                span {
                    margin-left: 2vw;
                }
            }
        }
    }
}
</style>
